import * as React from 'react';
import DataTables from 'material-ui-datatables';
import { ProgramMemberInfo } from './members.types';
import { Program } from '../programs/Types';
import { getPaginatedList } from '../util/pagination';

type Props = {
  readonly programs: Program[] | ProgramMemberInfo[]
  readonly programClickHandler?: Function
};

type States = {
  readonly programs: Program[] | ProgramMemberInfo[]
  readonly selectedRows: number[]
  readonly filteredPrograms: Program[] | ProgramMemberInfo[]
  readonly filterValue: string
  readonly currentPage: number
  readonly rowSize: number
};

class ProgramMemberTableComponent extends React.Component<Props, States> {
  constructor(props: Props) {
    super(props);

    this.state = {
      programs: this.props.programs,
      selectedRows: [],
      filteredPrograms: this.props.programs,
      filterValue: '',
      currentPage: 1,
      rowSize: 5
    };

    this.handleRowSelection = this.handleRowSelection.bind(this);
    this.handleFilterValueChange = this.handleFilterValueChange.bind(this);
    this.handleNextPageClick = this.handleNextPageClick.bind(this);
    this.handlePreviousPageClick = this.handlePreviousPageClick.bind(this);
    this.filterPrograms = this.filterPrograms.bind(this);
    this.getFilteredPrograms = this.getFilteredPrograms.bind(this);
  }

  componentDidMount() {
    this.filterPrograms();
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState(
      {programs: nextProps.programs},
      this.filterPrograms
    );  
  }

  render() {

    const TABLE_DATA: any = [];

    getPaginatedList(this.state.filteredPrograms, this.state.currentPage, this.state.rowSize)
    .map(function(program: any, index: number) {
      TABLE_DATA.push(
        (program.name) ? {
          program: program.name
        } : {
          program: program.program.name,
          level: program.level ? program.level.level : null
        });
    });

    const TABLE_COLUMNS = (TABLE_DATA.length > 0 && TABLE_DATA[0].level) ? [
      {
        key: 'program',
        label: 'Program'
      },
      {
        key: 'level',
        label: 'Level'
      }
    ] : [
      {
        key: 'program',
        label: 'Program'
      }
    ];

    return (
      <div className="row ma2">
        <div className="col-12">
          <DataTables
            height={'auto'}
            selectable={true}
            showRowHover={true}
            columns={TABLE_COLUMNS}
            data={TABLE_DATA}
            showHeaderToolbar={true}
            headerToolbarMode="filter"
            onRowSelection={this.handleRowSelection}
            selectedRows={this.state.selectedRows}
            filterValue={this.state.filterValue}
            onFilterValueChange={this.handleFilterValueChange}
            page={this.state.currentPage}
            rowSize={this.state.rowSize}
            showRowSizeControls={false}
            onNextPageClick={this.handleNextPageClick}		
            onPreviousPageClick={this.handlePreviousPageClick}
            count={this.state.filteredPrograms.length}
          />
        </div>
      </div>
    );
  }

  private handleRowSelection(selectedRows: number[]) {
    if (selectedRows.length === 0) {
      selectedRows = this.state.selectedRows;
    }
    const displayProgram = this.state.filteredPrograms[
      selectedRows[0] + ((this.state.currentPage - 1) * this.state.rowSize)
    ];
    if (this.props.programClickHandler) {
      this.props.programClickHandler(JSON.parse(JSON.stringify(displayProgram)));
    }

    this.setState({
      selectedRows: selectedRows
    });
  }

  private handleFilterValueChange(value: string) {

    this.setState(
      {
        filterValue: value,
        currentPage: 1
      },
      this.filterPrograms
    );
  }

  private handleNextPageClick() {
    this.setState(
      {
        currentPage: this.state.currentPage + 1,
      },
      this.filterPrograms
    );
  }

  private handlePreviousPageClick() {
    this.setState(
      {
        currentPage: this.state.currentPage - 1
      },
      this.filterPrograms
    );
  }

  private filterPrograms() {
    this.setState({
      filteredPrograms: this.getFilteredPrograms()
    });
  }

  private getFilteredPrograms(): Program[] | ProgramMemberInfo[] {
    let programsCopy: any[] = this.state.programs;
    let filteredPrograms = programsCopy.filter((program) => {
      return (program.name)
      ? program.name.toLowerCase().indexOf(this.state.filterValue.toLowerCase()) !== -1
      : program.program.name.toLowerCase().indexOf(this.state.filterValue.toLowerCase()) !== -1;
    });

    return filteredPrograms;
  }
}

export default ProgramMemberTableComponent;



// WEBPACK FOOTER //
// ./src/members/programMember.table.component.tsx